<template>


    <div class="payment-wrapper">
        <div class="head-cus">
            <p>{{ $t('paymentPage.paymentSelHeading')}}</p>
        </div>
        <div v-if="!(lsPaymentSettings&&lsPaymentSettings.length>0)&&isPaySettLsEmpty">
            {{ $t('paymentPage.noPaySelEnabled')}} <strong v-if="GET_CURRENCY">{{GET_CURRENCY.code}}</strong> {{
            $t('paymentPage.currency')}}.
            {{ $t('paymentPage.contactAdmin')}}
        </div>



        <div
                class="body system-pay-wrap"
                v-for="paymentType in lsPaymentSettings"
                :key="paymentType.groupId"
                v-bind:class="[{ 'option active': selectedPayType.groupId==paymentType.groupId?true:false},{'fullimage': (paymentType.groupId==providerGroup.systemPayment.groupId||paymentType.groupId==providerGroup.cashSales.groupId||paymentType.groupId==providerGroup.creditSales.groupId)?false:true}]"
        >

            <div class="details">
                <div class="title m-0"
                     @click="onSelectPayment(paymentType.paymentSettings&&paymentType.paymentSettings.length>0?paymentType.paymentSettings[0]:null)">
                    <div class="form-row form-inline">
                        <div role="group" class="custom-control custom-radio">
                            <input
                                    id="F0"
                                    type="radio"
                                    value="[object Object]"
                                    :checked="selectedPayType.groupId==paymentType.groupId?true:false"
                                    class="custom-control-input"
                            />
                            <label for="c" class="custom-control-label"></label>
                        </div>
                        {{paymentType.groupName}}
                    </div>
                </div>
                <div class="dec">
                    <p>
                        {{paymentType.description}}
                        <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus,
                        vitae. -->
                    </p>
                    <p>
                        <!-- Lorem ipsum dolor sit amet, consectetur adipisicing elit. -->
                    </p>
                </div>
            </div>
            <div class="options-wrap">
                <div
                        class="option-wrap " v-bind:class="[{ 'active': selectedPayType.paymentsettingsid==payment.paymentsettingsid?true:false },
                          { 'system-payment': paymentType.groupId=='SYSTEMPAYMENT'?true:false }
                          ]"
                        v-for="payment in paymentType.paymentSettings"
                        :key="payment.paymentsettingsid"
                >


                    <div @click="onSelectPayment(payment)" class="content-wrapper">
                        <div class="system-pay">
                            <div class="image">
                                <img :src="payment.logourl" alt="">
                            </div>
                            <div class="text-t">
                                {{payment.providername}}
                            </div>
                        </div>
                        <div class="logo">

                            <!-- https://upload.wikimedia.org/wikipedia/commons/2/28/HDFC_Bank_Logo.svg -->
                            <img :src="payment.logourl" alt/>
                        </div>


                    </div>
                    <!--                    <div class="text">-->
                    <!--                      {{payment.providername}}-->

                    <!--                    </div>-->


                </div>
            </div>

            <div v-if="selPayResDet">
                <div v-if="paymentType.groupId==providerGroup.cashSales.groupId&&selectedPayObject.groupId==providerGroup.cashSales.groupId">

                    <div  class="credit-sale-wrap" v-if="selectedPayObject.providertype==providerGroup.cashSales.providerType.cash">
                        <CRow>
                            <CCol md="6" class="d-flex align-item-center">

                                <div class="text-right ml-auto">
                                    {{ $t('paymentPage.totalAmountInCurr',{curr:selPayResDet.currency})}}
                                </div>
                            </CCol>
                            <CCol md="6">
                                <cTextInputComponent
                                        class="inner-label-none"
                                        v-model="selPayResDet.total"
                                        :isDisable="true"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="6" >
                                <label data-v-211fa86d="" for="" class="mb-4"></label>
                                <div class="text-right ml-auto">
                                    {{ $t('paymentPage.remarks')}}
                                </div>
                            </CCol>
                            <CCol md="6">
                                <cTextInputComponent

                                        v-model="selPaySubDetail.remarks"
                                        :placeholder=" $t('paymentPage.remarksPl')"
                                        :maxLength="30"
                                />
                            </CCol>
                        </CRow>






                    </div>
                    <div class="credit-sale-wrap" v-if="selectedPayObject.providertype==providerGroup.cashSales.providerType.bankTransfer">
                        <CRow>
                        <CCol md="6" class="d-flex align-item-center">

                            <div class="text-right ml-auto">
                                {{ $t('paymentPage.payReferenceNum')}}
                            </div>
                        </CCol>
                            <CCol md="6">
                                <cTextInputComponent
                                        :id="$t('paymentPage.payReferenceNumPl')" :ref="$t('paymentPage.payReferenceNumPl')"
                                        class="inner-label-none"
                                        v-model="selPaySubDetail.staffName"
                                        :placeholder=" $t('paymentPage.payReferenceNumPl')"
                                        :rules="'required|noInitialSpace'"
                                        :maxLength="15"
                                        :toEmit="true"
                                        @caughtError="scrollToElement"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="6">
                                <label for="" class="mb-4"></label>
                                <div class="text-right">
                                    {{ $t('paymentPage.remarks')}}
                                </div>
                            </CCol>
                            <CCol md="6">
                                <cTextInputComponent
                                        v-model="selPaySubDetail.remarks"
                                        :placeholder=" $t('paymentPage.remarksPl')"
                                        :maxLength="30"
                                />
                            </CCol>
                        </CRow>






                    </div>
                    <div class="credit-sale-wrap" v-if="selectedPayObject.providertype==providerGroup.cashSales.providerType.officeExpense">
                        <CRow>
                            <CCol md="6" class="d-flex align-item-center">

                                <div class="text-right ml-auto">
                                    {{ $t('paymentPage.staffName')}}
                                </div>
                            </CCol>
                            <CCol md="6">
                                <cTextInputComponent
                                :id="$t('paymentPage.staffNamePl')" :ref="$t('paymentPage.staffNamePl')"
                                        class="inner-label-none"
                                        v-model="selPaySubDetail.staffName"
                                        :placeholder=" $t('paymentPage.staffNamePl')"
                                        :maxLength="30"
                                        :rules="'required|onlyAlphabets|noInitialSpace'"
                                        :isEmit="true"
                                         @caughtError="scrollToElement"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="6" >
                                <label data-v-211fa86d="" for="" class="mb-4"></label>
                                <div class="text-right ml-auto">
                                    {{ $t('paymentPage.remarks')}}
                                </div>
                            </CCol>
                            <CCol md="6">
                                <cTextInputComponent
                                        v-model="selPaySubDetail.remarks"
                                        :placeholder=" $t('paymentPage.remarksPl')"
                                        :maxLength="30"

                                />
                            </CCol>
                        </CRow>

                        <span></span>


                    </div>


                </div>
                <div v-else-if="paymentType.groupId==providerGroup.creditSales.groupId&&selectedPayObject.groupId==providerGroup.creditSales.groupId">
                    <div v-if="selectedPayObject.providertype==providerGroup.creditSales.providerType.credit">

                        <div class="credit-sale-wrap">
                            <CRow>
                                <CCol md="6" class="d-flex align-items-center">
                                    <span class="mb-auto mt-12px ml-auto">{{$t('paymentPage.smallAgent')}}</span>
                                </CCol>
                                <CCol md="6">
                                    <CRow>
                                        <CCol md="8" class="blue-border-dropdown">
                                            <ValidationProvider
                                                    v-slot="{ errors }"
                                                    :rules="'required'">
                                                <multiselect
                                                        v-model="selPaySubDetail.selSubAgent"
                                                        :id="$t('paymentPage.smallAgentPl')"
                                                        :ref="$t('paymentPage.smallAgentPl')"
                                                        label="name"
                                                        :allow-empty="true"
                                                        :options="subAgentList"
                                                        :track-by="'id'"
                                                        deselectLabel
                                                        deselectGroupLabel
                                                        selectLabel
                                                        class="inner-label-none"
                                                        selectedLabel
                                                        :custom-label="customLabel"
                                                        :placeholder="$t('paymentPage.smallAgentPl')"
                                                        @open="onGetAllSubAgents"
                                                >
                                                    <template #noResult>
                                                        <strong>{{$t('paymentPage.listEmpty')}}</strong>
                                                    </template>
                                                </multiselect>
                                                <div
                                                        v-if="errors && errors[0]" v-getDpError="caughtDpError($t('paymentPage.smallAgentPl'))"
                                                        class="invalid-feedback icon"
                                                >
                                                    <span>{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </CCol>
                                        <CCol md="4" class="pl-0 d-flex align-item">
                                            <div class="add-ml-flight d-flex" @click="onAddSmallAgent">
                                                <img src="@imgPath/img/svg/icons/blue-icons/circle_add.svg" alt
                                                     width="30"/>
                                            </div>
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="selPaySubDetail.selSubAgent">
                                        <CCol md="8">
                                            <div class="bg-gray-c-gray h-100">
                                                <div>
                                                    <CRow>
                                                        <CCol md="4">
                                                    <span>
                                                        Name
                                                    </span>
                                                        </CCol>
                                                        <CCol md="8">
                                                        <span>
                                                        {{selPaySubDetail.selSubAgent.name}}
                                                        </span>

                                                        </CCol>
                                                    </CRow>
                                                    <CRow>
                                                        <CCol md="4">
                                                    <span>
                                                    {{$t('paymentPage.mobile')+' '}}
                                                    </span>

                                                        </CCol>
                                                        <CCol md="8">
                                                    <span>
                                                    {{selPaySubDetail.selSubAgent.mobileNumber}}
                                                    </span>

                                                        </CCol>
                                                    </CRow>
                                                    <CRow>
                                                        <CCol md="4">
                                                        <span class="white-space-pre">{{$t('paymentPage.email')+' '}}
                                                        </span>

                                                        </CCol>
                                                        <CCol md="8">
                                                        <span>
                                                            {{selPaySubDetail.selSubAgent.emailid}}
                                                        </span>
                                                        </CCol>
                                                    </CRow>
                                                    <CRow>
                                                        <CCol md="4">
                                                        <span>
                                                        {{$t('paymentPage.address')+' '}}
                                                        </span>

                                                        </CCol>
                                                        <CCol md="8">
                                                        <span>
                                                        {{selPaySubDetail.selSubAgent.address}}
                                                        </span>

                                                        </CCol>
                                                    </CRow>

                                                </div>

                                            </div>
                                        </CCol>
                                        <CCol md="4" class="pl-0">
                                            <div class="bg-gray-c-gray h-100">
                                                <div>
                                                    <span>{{$t('paymentPage.creditBalance')}}</span>
                                                </div>
                                                <br />
                                                <table class="w-100">
                                                    <tbody>
                                                    <tr v-for="(currObj,index) in selPaySubDetail.selSubAgent.b2bSubagentFinances"
                                                        :key="index">

                                                        <td>
                                                            <span>{{currObj.currencycode+' '}}</span>
                                                        </td>
                                                        <td class="text-right">
                                                            <span class="pl-2">{{currObj.runningbalance}}</span>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </CCol>
                                    </CRow>

                                </CCol>


                            </CRow>
                            <CRow>
                                <CCol md="6">
                                    <label for="" class="pb-3"></label>
                                    <div class="text-right">
                                    {{ $t('paymentPage.totalAmountInCurr',{curr:selPayResDet.currency})}}
                                    </div>
                                </CCol>
                                <CCol md="6">
                                    <CRow>
                                        <CCol md="8">
                                            <cTextInputComponent
                                                    v-model="selPayResDet.total"
                                                    :isDisable="true"
                                            />
                                        </CCol>
                                    </CRow>

                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="6">
                                    <label for="" class="pb-3"></label>
                                    <div class="text-right">
                                    {{ $t('paymentPage.cashReceivedPay',{curr:selPayResDet.currency})}}
                                    </div>
                                </CCol>
                                <CCol md="6">
                                    <CRow>
                                        <CCol md="8">
                                            <cTextInputComponent :isAmountField="true"
                                                                 :placeholder=" $t('paymentPage.cashReceivedPayPl')"
                                                                 :rules="'required|onlynumber|no_zero|validDecimal|'+'payUseCashSale:'+selPayResDet.total"
                                                                 @onBlur="formatPaidAmount(selPaySubDetail.paidAmount)"
                                                                 @onFocus="onRemoveCurrFormat(selPaySubDetail.paidAmount)"
                                                                 v-model="selPaySubDetail.paidAmount"
                                                                 @input="onChangePaidAmount"
                                                                 :toEmit="true"
                                                                 @caughtError="scrollToElement"
                                                                  :id="$t('paymentPage.cashReceivedPayPl')" :ref="$t('paymentPage.cashReceivedPayPl')"
                                            />
                                        </CCol>
                                    </CRow>

                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="6">

                                    <label for="" class="pb-3"></label>
                                    <div class="text-right">
                                    {{ $t('paymentPage.balanceAmount',{curr:selPayResDet.currency})}}
                                    </div>

                                </CCol>
                                <CCol md="6">
                                    <CRow>
                                        <CCol md="8">
                                            <cTextInputComponent
                                                    v-model="selPaySubDetail.balanceAmount"
                                                    :isDisable="true"
                                            />
                                        </CCol>
                                    </CRow>

                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="6">
                                    <label for="" class="pb-3"></label>
                                    <div class="text-right">
                                    {{ $t('paymentPage.remarks')}}
                                    </div>

                                </CCol>
                                <CCol md="6">
                                    <CRow>
                                        <CCol md="8">
                                            <cTextInputComponent
                                                    v-model="selPaySubDetail.remarks"
                                                    :placeholder=" $t('paymentPage.remarksPl')"
                                                    :maxLength="30"

                                            />
                                        </CCol>
                                    </CRow>

                                </CCol>
                            </CRow>
                        </div>


                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";

import {
  handleJWT,
  getErrorAlertValue,
  cloneData,
  addClassToBody,
  removeClassBody,
  handleSessionExist,
  navigateByHostUrl,
  cloneDeep,OrderBy,OrderByList,removeCurrFormat, onOpenLink
  
} from "../../../util/util";
import router, { navigate, goBack } from "../../../router/index";

import { mapGetters, mapActions } from "vuex";
// import apiSelectPayment from "../../services/apiSelectPayment";
import apiGetPaymentSettings from "../../../services/apiGetPaymentSettings";
import apiGetPaySettingsForTicketing from "../../../services/apiGetPaySettingsForTicketing";
import apiGetPaymentListForTopUp from "../../../services/apiGetPaymentListForTopUp";
    import cTextInputComponent from "../../../components/form/cTextInputComponent";

import {
  COMPONENT_NAME,
  PATHNAME,
  ROUTER_PARAM,
  PAX,
  TOAST_TYPE,
  PROCEED_TO_TYPE,
  PAYMENT_FOR,ORDER, PAYMENT_PROVIDER_GROUP,
} from "../../../util/constants";
import Logger from "../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../config/API_DATA";
import BaseConfiguration from "../../../config/base";
import apiGetAllSubAgent from "../../../services/apiGetAllSubAgent";
 import Multiselect from "vue-multiselect";
     import Vue from "vue";
    import { ValidationProvider} from "vee-validate";

export default {
  components:{
   cTextInputComponent,
   Multiselect,
   ValidationProvider
  },
    name:COMPONENT_NAME.C_BOOKING_PAY_LIST,
     props: {
    // paymentFor:{
    //    type:String,
    //    default: null
    // },
    selectedPayObject:{
   type:Object,
    default: null

    },
    selPayResDetails:{
      type:Object,
      default:null
    }

     },
    data: () => ({
        lsPaymentSettings:[],
        selectedPayType: {
      paymentsettingsid: null,
      groupId: null,
      providertype:null
        },
        isPaySettLsEmpty:false,
      providerGroup:PAYMENT_PROVIDER_GROUP,
     
     selPayResDet:null,
     selPaySubDetail:{
       remarks:null,
       paymentReferenceNum:null,
       staffName:null,
       balanceAmount:null,
       paidAmount:null,
       selSubAgent:null
     },
     isRouteAssToRemark:false,
      subAgentList:[],
      isPaidAmtField:true
    
}),
  watch: {
    selPayResDetails: {
      immediate: false,
      deep: true,
      handler: function(newVal, oldVal) {
        this.selPayResDet = this.selPayResDetails;
        if(!this.selPaySubDetail.remarks&&!this.isRouteAssToRemark&&this.selectedPayType.providertype==this.providerGroup.cashSales.providerType.cash){
          this.selPaySubDetail.remarks= this.selPayResDet.remarks;
          this.isRouteAssToRemark=true;
        }
        if(this.selPayResDet.total){
       this.selPayResDet.total= this.$options.filters.currencyFormat(
                  this.selPayResDet.total,
                   this.selPayResDet.currency
                  );
        }
        this.selPaySubDetail.balanceAmount=this.getBalanceAmount(this.selPayResDet,this.selPaySubDetail);
     
     }
    },
     selPaySubDetail: {
      immediate: false,
      deep: true,
      handler: function(newVal, oldVal) {
        let selPayDet=cloneDeep(this.selPaySubDetail);
        this.$emit('getSelPaySubDetail',selPayDet);
       
        //  this.selPaySubDetail.balanceAmount=this.getBalanceAmount(this.selPayResDet,this.selPaySubDetail);
      
    },
     }
    
  },
        computed: {
    //          ...mapGetters("sPaymentPage", {
    //   sSelectedPayTypeObj: "GET_SEL_PAY_TYPE_OBJ"
    // }),
     ...mapGetters("sTicketingQueue", {
      GET_TICKETING_QUEUE: "GET_TICKETING_QUEUE"
    }),
   ...mapGetters("sPrepaidTopUp", {
      GET_SELECTED_CURRENCY: "GET_SELECTED_CURRENCY"
    }),

...mapGetters("sResult", {
               GET_CURRENCY:"GET_CURRENCY"
            }),
//  'paymentType.paymentSettings': function () {
//     return OrderBy(this.lsPaymentSettings.paymentSettings, 'displayorder')
//   }


        },
        methods: {
             ...mapActions("sPaymentPage", {
      SET_PAY_TYPE_OBJ: "SET_PAY_TYPE_OBJ"
    }),
  //   orderBy(ls) {
  //   return OrderBy(ls, 'displayorder')
  // },

  scrollToElement(pRef) {
                var el = null;
                if(pRef == this.$t('paymentPage.cashReceivedPayPl')) { 
                     el = this.$refs[this.$t('paymentPage.cashReceivedPayPl')];
                }
                if(pRef == this.$t('paymentPage.staffNamePl')) { 
                     el = this.$refs[this.$t('paymentPage.staffNamePl')];
                }
                if(pRef == this.$t('paymentPage.payReferenceNumPl')) { 
                     el = this.$refs[this.$t('paymentPage.payReferenceNumPl')];
                }
                if(pRef == this.$t('paymentPage.smallAgentPl')) { 
                     el = this.$refs[this.$t('paymentPage.smallAgentPl')];
                }
                if (el) {
                    if(el[0]){
                        el[0].$el.scrollIntoView({ behavior: "smooth" });
                    }
                   
                }
  },

  customLabel(option) {
      return `${option.name} `;
    },
        async onGetAllSubAgents() {
        try {
          if(BaseConfiguration.isDebug) console.log("onGetAllSubAgents");
               this.subAgentList = await this.getAllSubAgent();
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_PAYMENT_LIST,
                  "error in onGetAllSubAgents",
                  err.toString(),
                  "onGetAllSubAgents",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        }, 
     onAddSmallAgent() {
         try {
           if(BaseConfiguration.isDebug) console.log("onAddSmallAgent");
         onOpenLink(window.location.origin+'/#'+PATHNAME.ADD_PROFILE);
     
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.C_BOOKING_PAY_LIST,
                   "error in onAddSmallAgent",
                   err.toString(),
                   "onAddSmallAgent",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           
         }, 

     onChangePaidAmount() {
       let retValue;
         try {
           if(BaseConfiguration.isDebug) console.log("onChangePaidAmount");
          this.selPaySubDetail.balanceAmount=this.getBalanceAmount(this.selPayResDet,this.selPaySubDetail);
      
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.C_BOOKING_PAY_LIST,
                   "error in onChangePaidAmount",
                   err.toString(),
                   "onChangePaidAmount",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
         }, 
     getBalanceAmount(pSelPayResDet,pSelPaySubDetail) {
       let retValue=null;
         try {
           if(BaseConfiguration.isDebug) console.log("getBalanceAmount");
           if(pSelPayResDet&&pSelPayResDet.total){
             if(pSelPaySubDetail.paidAmount&&Number(pSelPaySubDetail.paidAmount)<=Number(pSelPayResDet.total)){
               retValue=Number(pSelPayResDet.total)-Number(pSelPaySubDetail.paidAmount)
             }else{
               retValue=pSelPayResDet.total;
             }
            retValue= this.$options.filters.currencyFormat(
                  retValue,
                   pSelPayResDet.currency
                  );
        
           }else{
             retValue=null;
           }
     
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.C_BOOKING_PAY_LIST,
                   "error in getBalanceAmount",
                   err.toString(),
                   "getBalanceAmount",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           return retValue;
         }, 
     formatPaidAmount(val) {
                if (BaseConfiguration.isDebug) console.log(" formatPaidAmount");
                try {
                  if(val&&this.selPayResDet&&this.selPayResDet.currency){
                   this.selPaySubDetail.paidAmount= this.$options.filters.currencyFormat(val, this.selPayResDet.currency);
                    // this.isPaidAmtField=false;
                    // let that = this;
                    //      Vue.nextTick(function () {
                    //         that.isPaidAmtField = true;
                    //     });
                  }
                 
                    // this.creditNote.creditAmount = this.creditAmount;
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_PAY_LIST,
                        "error in formatPaidAmount",
                        err.toString(),
                        "formatPaidAmount",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
       onRemoveCurrFormat(pAmount) {
                try {
                    if (BaseConfiguration.isDebug) console.log("onRemoveCurrFormat");

                    this.selPaySubDetail.paidAmount = removeCurrFormat(pAmount);
             
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_BOOKING_PAY_LIST,
                        "error in onRemoveCurrFormat",
                        err.toString(),
                        "onRemoveCurrFormat",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
             //method to call while selecting a payment
    async onSelectPayment(pPaymentType) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSelectPayment");
        
        this.selPaySubDetail={
        remarks:null,
       paymentReferenceNum:null,
       staffName:null,
       balanceAmount:null,
       paidAmount:null,
       selSubAgent:null
        }
        if(pPaymentType)
        {
        /*this.selectedPayType.paymentsettingsid = pPaymentType.paymentsettingsid;
        this.selectedPayType.groupId = pPaymentType.groupid;
        this.selectedPayType.providertype = pPaymentType.providertype;*/ //dont assign "this" multiple times

        this.selectedPayType = {
            paymentsettingsid: pPaymentType.paymentsettingsid,
            groupId: pPaymentType.groupid,
            providertype:pPaymentType.providertype
        }

        if (this.selectedPayType) {
            this.$emit("getSelPayment",this.selectedPayType)
        
        
         }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_PAY_LIST,
          "error in onSelectPayment",
          err.toString(),
          "onSelectPayment",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },


    
   
    async getPaySettingsRes() {
      try {
        let retValue;
        if (BaseConfiguration.isDebug) console.log("getPaySettingsRes");
        let paySettingsRequest = apiGetPaymentSettings.buildRequest(
          this.$router.currentRoute.query[ROUTER_PARAM.SESSION_ID]
        );

        if (paySettingsRequest) {
          let paySettingsResponse = await apiGetPaymentSettings.getResponse(
            paySettingsRequest
          );

          if (VALIDATE_SUCCESS_RES(paySettingsResponse)) {

            retValue = paySettingsResponse.data.data;
          } else {
            let error = getErrorMessage(paySettingsResponse);
            // let isSessionExpired = handleSessionExist(paySettingsResponse.data);
            let isSessionExpired;
            if(paySettingsResponse){
              isSessionExpired = handleSessionExist(paySettingsResponse.data);
            }
            // if (retSessionVal) {
            //   this.showToast(retSessionVal, TOAST_TYPE.ERROR, 5000, null);
            // }
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "Failed to create payment settings request.";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_PAY_LIST,
          "error in getPaySettingsRes",
          err.toString(),
          "getPaySettingsRes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
async getPaySettResForTicketing() {
      try {
        let retValue;
        if (BaseConfiguration.isDebug) console.log("getPaySettResForTicketing");
        let paySettingsRequest = apiGetPaySettingsForTicketing.buildRequest(
          this.GET_TICKETING_QUEUE.orderId
        );

        if (paySettingsRequest) {
          let paySettingsResponse = await apiGetPaySettingsForTicketing.getResponse(
            paySettingsRequest
          );

          if (VALIDATE_SUCCESS_RES(paySettingsResponse)) {
            retValue = paySettingsResponse.data.data;
          } else {
            let error = getErrorMessage(paySettingsResponse);
            // let isSessionExpired = handleSessionExist(paySettingsResponse.data);
            let isSessionExpired;
            if(paySettingsResponse){
              isSessionExpired = handleSessionExist(paySettingsResponse.data);
            }
            // if (retSessionVal) {
            //   this.showToast(retSessionVal, TOAST_TYPE.ERROR, 5000, null);
            // }
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "Failed to create payment settings request for ticketing.";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_PAY_LIST,
          "error in getPaySettResForTicketing",
          err.toString(),
          "getPaySettResForTicketing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async getPaySettResForTopUp() {
      try {
        let retValue;
        if (BaseConfiguration.isDebug) console.log("getPaySettResForTicketing");
        let paySettingsRequest = apiGetPaymentListForTopUp.buildRequest(
        this.GET_SELECTED_CURRENCY
        );

        if (paySettingsRequest) {
          let paySettingsResponse = await apiGetPaymentListForTopUp.getResponse(
            paySettingsRequest
          );

          if (VALIDATE_SUCCESS_RES(paySettingsResponse)) {
            retValue = paySettingsResponse.data.data;
          } else {
            let error = getErrorMessage(paySettingsResponse);
            // let isSessionExpired = handleSessionExist(paySettingsResponse.data);
            let isSessionExpired;
            if(paySettingsResponse){
              isSessionExpired = handleSessionExist(paySettingsResponse.data);
            }
            // if (retSessionVal) {
            //   this.showToast(retSessionVal, TOAST_TYPE.ERROR, 5000, null);
            // }
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "Failed to create payment settings request for ticketing.";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_PAY_LIST,
          "error in getPaySettResForTicketing",
          err.toString(),
          "getPaySettResForTicketing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
     
     getPropToSort(pPayment){
       if (pPayment.clientPricing != null) {
          return pFlightObj.clientPricing.AdultPrice.Total;
        }
     },
     getSortedList(pListPaySettings) {
        let retValue=[];
         try {
           if(BaseConfiguration.isDebug) console.log("getSortedList");
           if(pListPaySettings)
           {
           let settingsList=pListPaySettings;
          if(settingsList){
           for(let i=0;i< settingsList.length;i++){
                        // for(let j=0;j< pListPaySettings[i].paymentSettings.length;j++){
              settingsList[i].paymentSettings=OrderBy(settingsList[i].paymentSettings,'displayorder');
                        // }

           }
             retValue= settingsList;
                
          }
           }
     
         } catch (err) {
                 let body = Logger.buildRequest(
                   COMPONENT_NAME.C_BOOKING_PAY_LIST,
                   "error in getSortedList",
                   err.toString(),
                   "getSortedList",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
           return retValue;
         }, 
        async getAllSubAgent() {
      let retValue=[];
      try {
          
        let getAllSubAgentReq;
        
          getAllSubAgentReq = apiGetAllSubAgent.buildRequest();
       
        if (getAllSubAgentReq) {
          let getAllSubAgentRes = await apiGetAllSubAgent.getResponse(
            getAllSubAgentReq
          );

          if (VALIDATE_SUCCESS_RES(getAllSubAgentRes)) {
            retValue = getAllSubAgentRes.data.data.allSubAgents;
         
            this.alertValue=null;
          } else {
            let error = getErrorMessage(getAllSubAgentRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
             
          }
        } else {
          throw "invalid agent";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_BOOKING_PAY_LIST,
          "error in getting response from getAllSubAgent API",
          err.toString(),
          "getAllSubAgent",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    caughtDpError(pRef){
      this.scrollToElement(pRef);
    }
        },
directives: {
  getDpError: {
    // directive definition
    inserted: function (el) {
      el.focus()
    }
  },
  },
        async created() {
              try {
        this.$on('caughtDpError', this.caughtDpError /*the name of the method to call */)
    this.lsPaymentSettings = await this.getPaySettingsRes();
    
             if (this.selectedPayObjectj) {
        this.selectedPayType = this.selectedPayObject;     
        this.$emit("getSelPayment",this.selectedPayType,this.lsPaymentSettings)

      
      }
    
         if(this.lsPaymentSettings&&this.lsPaymentSettings.length==0){
                 this.$emit("getPaySettingsList",this.lsPaymentSettings)
          this.isPaySettLsEmpty=true;
         }
         this.lsPaymentSettings=this.getSortedList(this.lsPaymentSettings);

              //  this.subAgentList = await this.getAllSubAgent();

              } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_BOOKING_PAY_LIST,
        "error while created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }

        }
}
</script>